import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates-assets/category/{category}']['GET'];

type Input = {
  category: string;
};

type Output = ThisApi['response'];

const getDynamicPdfTemplatesAssetsByCategory = async ({ category }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates-assets/category/${category}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates:', error);
    throw error;
  }
};

export default getDynamicPdfTemplatesAssetsByCategory;
